@if (biography) {
  <div class="row justify-content-center">
    <div class="col-sm-10 col-md-8 m-auto mt-5 mb-5">
      <div [class]="biography.classNames + ' biography'">
        <div class="d-flex align-middle biography-content" tabindex="{0}" (click)="openModal()" (keydown)="openModal()">
          <div class="biography-image-wrapper">
            <img ngSrcset="200w" width="200" [alt]="biography.name" [src]="biography.image" />
          </div>
          <p>{{ biography.title }}</p>
        </div>
      </div>
    </div>
  </div>
  <ui-modal sourceId="biographyModal">
    <div class="modal-container text-center">
      <img ngSrcset="200w" width="200" [alt]="biography.name" [src]="biography.image" />
      <div [innerHtml]="biography.description | sanitizeContentfulHTML"></div>
    </div>

    <ul class="">
      @for (article of biography.articleListsForBiographyModal; track $index) {
        <li>
          <a [href]="article.slug">{{ article.title }}</a>
        </li>
      }
    </ul>
  </ui-modal>
}
